export const actionTypes = {
  CHANGE_SCREEN_TYPE: 'CHANGE_SCREEN_TYPE',
};

export const changeScreenType = (screenType) => ({
  type: actionTypes.CHANGE_SCREEN_TYPE,
  screenType,
});
